import { useOverlayStore } from '@/ds/overlay-store'
import { confirmDialog, showDialog } from '@/ds/dialog'
import { showFullScreen, showSheet } from '@/ds/sheet'
import { DsToast, ToastHost } from '@/ds/toast'

// Pick the lightest surface that fits; never stack more than one sheet or dialog.
export const DsOverlay = {
  toast: DsToast.show,
  confirm: confirmDialog,
  dialog: showDialog,
  sheet: showSheet,
  fullScreen: showFullScreen,
}

export function OverlayHost() {
  const entries = useOverlayStore((s) => s.entries)
  return (
    <>
      {entries.map((e) => (
        <div key={e.id} className="contents">
          {e.render()}
        </div>
      ))}
      <ToastHost />
    </>
  )
}
